export enum EReceiptStatus {
  OK = 'OK',
  ER = 'ER',
  PC = 'PC',
  PENDING = '',
}

export enum IReceiptStatus {
  OK = 'OK',
  PC = 'PC',
  PENDING = '',
}
